import { PlanningItemApi, StorageApi } from '@phrospr/api-backend';

// Planning-item attachments via the generated client (the endpoints moved
// from raw express routes into TSOA controllers).

export async function uploadPlanningItemAttachment(planning_item_id: number, calendar_item_id: number, file: File) {
    await PlanningItemApi.uploadPlanningItemAttachment(planning_item_id, file, calendar_item_id);
}

export async function downloadPlanningItemAttachment(fileName: string): Promise<Blob> {
    return (await StorageApi.downloadStorageFile(fileName, { responseType: 'blob' })).data as unknown as Blob;
}

export async function deletePlanningItemAttachment(planning_item_attachment_id: number): Promise<void> {
    await PlanningItemApi.deletePlanningItemAttachment(planning_item_attachment_id);
}
